// Cart drawer Featured card: Men's / Women's segmented toggle (snippets/upsell-feat-card.liquid).
// Tapping a side sets the variant the Add button submits and swaps the card photo and price.
// Delegated from document so it survives cart drawer re-renders. Loaded site-wide because the
// card can render on the first add, before assets/upsell.js has loaded.
(function () {
  if (window.__skFeatToggle) return;
  window.__skFeatToggle = true;

  document.addEventListener('click', function (e) {
    var opt = e.target && e.target.closest && e.target.closest('.sk-feat-seg__opt');
    if (!opt || opt.disabled) return;
    e.preventDefault();
    var card = opt.closest('[data-sk-featured]');
    if (!card) return;

    card.querySelectorAll('.sk-feat-seg__opt').forEach(function (b) {
      b.setAttribute('aria-checked', b === opt ? 'true' : 'false');
    });

    var input = card.querySelector('input[name="id"]');
    if (input) { input.value = opt.dataset.variantId; input.disabled = false; }
    var add = card.querySelector('button[name="add"]');
    if (add) { add.disabled = false; add.textContent = 'Add'; }

    var img = card.querySelector('[data-sk-feat-img]');
    if (img && opt.dataset.img) img.src = opt.dataset.img;
    var price = card.querySelector('.upsell-cart__card-price');
    if (price && opt.dataset.price) price.textContent = opt.dataset.price;
    if (opt.dataset.url) {
      card.querySelectorAll('[data-sk-feat-link]').forEach(function (a) { a.setAttribute('href', opt.dataset.url); });
    }
  });

  // Arrow keys move between options, as a radiogroup should.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var opt = e.target && e.target.closest && e.target.closest('.sk-feat-seg__opt');
    if (!opt) return;
    var opts = Array.prototype.slice.call(opt.parentNode.querySelectorAll('.sk-feat-seg__opt:not([disabled])'));
    var i = opts.indexOf(opt) + (e.key === 'ArrowRight' ? 1 : -1);
    var next = opts[(i + opts.length) % opts.length];
    if (next) { e.preventDefault(); next.focus(); next.click(); }
  });
})();
